import React from "react";
import { endpoints } from "config";
import * as Yup from "yup";

import { FieldRenderers, FormField } from "@avamae/formbuilder";

import Entity from "components/Entity";
import { WFA } from "./components/WorkFlowActionItem";
import { HomeFields } from "./models";
import { WorkFlowProgress } from "./components/WorkFlowProgress";
import { stringV2Renderer } from "components/helpers/CustomFieldRenderers/CustomString/StringV2";

const validationSchema = Yup.object({});

type Props = {
  actionType: "create" | "edit" | "view";
  selectedData: WFA[];
  onDone(): void;
  idFromRowOption: React.ReactText | null;
};

const fetchConfig = (
  selectedRows: WFA[],
  idFromRowOption?: React.ReactText | null
) => {
  return {
    params: {
      Id: idFromRowOption ?? selectedRows[0].workflowInstances__Id,
      // (selectedRows[0].restrictedWorkflow__bWorkflowAction //userActionApprovals__bWorkflowAction
      //   ? selectedRows[0].workflowActionInstances__Id //userActionApprovals__WorkflowActionInstancesID
      //   : selectedRows[0].workflowApprovalInstances__Id), //userActionApprovals__WorkflowApprovalInstancesID
    },
  };
};

const rightsRenderer = (): FieldRenderers<HomeFields> => ({
  custom: <T,>(_key: React.ReactText, field: FormField<T>) => (
    <WorkFlowProgress
      label={field.label as string}
      fieldName={field.name as string}
    />
  ),
});

const readOnlyRightsRenderer = (): FieldRenderers<HomeFields> => ({
  string: stringV2Renderer(true, null, null),
  unknown: <T,>(_key: React.ReactText, field: FormField<T>) => (
    <WorkFlowProgress
      label={field.label as string}
      fieldName={field.name as string}
    />
  ),
});

function StartNewWorkflow(props: Props): JSX.Element {
  const { actionType, selectedData, idFromRowOption } = props;

  const initialDataUrl = endpoints.home.viewWorkflow;

  return (
    <Entity
      initialDataUrl={initialDataUrl}
      readOnly={actionType === "view"}
      submitUrl={initialDataUrl}
      onDone={props.onDone}
      selectedData={selectedData}
      idFromRowOption={idFromRowOption}
      formType="json"
      validationSchema={validationSchema}
      nullStringValues={[]}
      fetchConfig={actionType === "create" ? undefined : fetchConfig}
      noSubmit
      hideActionButton
      fieldRenderers={rightsRenderer}
      readOnlyFieldRenderers={readOnlyRightsRenderer}
      hideViewGroupLabel={true}
      groupColumns={actionType === "view" ? { workflowprogress: 2 } : undefined}
    />
  );
}

export default StartNewWorkflow;
